export default __webpack_public_path__ + "static/media/RevenueRecaptureLeft.441ffc27.png";